import { usePage } from '@inertiajs/react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { FdeCopy, ProjectAgent } from '@/frontend/features/Fde/types'
import type { SharedProps } from '@/frontend/types/inertia'

export default function ProjectAgentSyncStatus({ assignment, copy }: { assignment: ProjectAgent; copy: FdeCopy }) {
  const labels = usePage<SharedProps>().props.navigationLabels.forge
  const statuses = [assignment.mcp_sync_status, assignment.repository_sync_status]
  const failed = statuses.includes('failed')
  const pending = statuses.includes('pending')
  const ready = statuses.every((status) => status === 'synced')
  const label = failed ? labels.agent_sync_failed : pending ? labels.agent_sync_pending : ready ? labels.agent_sync_ready : copy.forms.repository_unconfigured
  const details = `${copy.forms[`mcp_${assignment.mcp_sync_status}`]} · ${copy.forms[`repository_${assignment.repository_sync_status}`]}`
  return <Tooltip><TooltipTrigger asChild>
    <span tabIndex={0} aria-label={details} className="inline-flex shrink-0 items-center gap-1.5 text-[11px] text-muted-foreground">
      <span aria-hidden className={`size-1.5 rounded-full ${failed ? 'bg-destructive' : pending ? 'bg-amber-500' : ready ? 'bg-emerald-500' : 'bg-muted-foreground'}`} />
      <span className="hidden sm:inline">{label}</span>
    </span>
  </TooltipTrigger><TooltipContent side="top" className="max-w-72 break-words">
    <p>{copy.forms[`mcp_${assignment.mcp_sync_status}`]}</p><p>{copy.forms[`repository_${assignment.repository_sync_status}`]}</p>
    {assignment.mcp_sync_error && <p className="mt-1 text-destructive">{assignment.mcp_sync_error}</p>}
    {assignment.repository_sync_error && <p className="mt-1 text-destructive">{assignment.repository_sync_error}</p>}
  </TooltipContent></Tooltip>
}
